import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DocumentsToChargeDialogComponent } from 'src/app/components/dialogs/documents-to-charge-dialog/documents-to-charge-dialog.component';
import { routesData } from '../resources/routes.constant';
import { CustomerDataService } from './customer-data.service';
import { MoreInfoService } from './more-info.service';
import { RecaptchaDialogComponent } from 'src/app/components/dialogs/recaptcha-dialog/recaptcha-dialog.component';
import { ConfirmFormUserComponent } from 'src/app/components/dialogs/confirm-form-user/confirm-form-user.component';
import { BackRedirectionDialogComponent } from 'src/app/components/dialogs/back-redirection-dialog/back-redirection-dialog.component';
import { TagAvalDialogComponent } from 'src/app/components/dialogs/tag-aval-dialog/tag-aval-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogOptionsService {
  dialogRef: MatDialogRef<any> | undefined;
  dialogOptions: any;
  mapper: any = {
    documentsToChargeDialogComponent: DocumentsToChargeDialogComponent,
    recaptchaDialogComponent: RecaptchaDialogComponent,
    confirmFormUserComponent: ConfirmFormUserComponent,
    backRedirection: BackRedirectionDialogComponent,
    tagAval: TagAvalDialogComponent
  };
  constructor(
    public dialog: MatDialog,
    public breakpointObserver: BreakpointObserver,
    private moreInfoService: MoreInfoService,
    private router: Router,
    public data: CustomerDataService
  ) {
    this.dialogOptions = {
      disableClose: true,
      panelClass: 'dialog-overlay',
      maxWidth: this.breakpointObserver.isMatched('(max-width: 420px)')
        ? '100vw'
        : '420px'
    };
  }

  openDialog(component: string) {
    return this.dialog.open(this.mapper[component], this.dialogOptions);
  }

  openDocumentsToChargeDialog(component: string): void {
    this.dialogRef = this.openDialog(component);
    this.dialogRef.afterClosed().subscribe(() => {
      this.moreInfoService.setMoreInfo({
        ...this.moreInfoService.moreInfoData,
        isUploadedAnyDoc: true
      });
      this.router.navigate([routesData.DIGITAL_SIGNATURE.redirectPath]);
    });
  }

  openRecaptchaDialog(component: string): any {
    this.dialogOptions.disableClose = false;
    return this.openDialog(component);
  }

  openConfirmDialog(component: string, email: string, cellPhone: string) {
    this.dialogOptions.disableClose = false;
    this.dialogOptions.data = { email: email, cellphone: cellPhone };
    this.dialogOptions.width = '420px';
    return this.openDialog(component);
  }

  openDialogCustom(component: string, options: any) {
    return this.dialog.open(this.mapper[component], options);
  }

  openDialogWithCustomOptions(
    component: string,
    className: string,
    options: any
  ) {
    const dialogOptions: any = {
      ...this.dialogOptions,
      ...options,
      panelClass: className
    };
    this.dialogRef = this.openDialogCustom(component, dialogOptions);
  }

  getCurrentDialogRef() {
    return this.dialogRef;
  }

  closeDialog(closeTemp: boolean) {
    return this.dialogRef?.close(closeTemp);
  }
}
